import React, { useState, useEffect, useCallback } from 'react';
import { Table, Card, Input, Button, message } from 'antd';
import { useQuery } from 'react-query';
import apiClient from '../utils/apiClient';
import { getAllHubAppProfiles } from '../services/hubAppProfileService';

const toCamelCase = (value) =>
  value
    .toLowerCase()
    .split('_')
    .map((part, idx) => (idx === 0 ? part : part.charAt(0).toUpperCase() + part.slice(1)))
    .join('');

const ZohoAccounts = () => {
  const [loading, setLoading] = useState(false);
  const [accounts, setAccounts] = useState([]);
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10, total: 0 });
  const [query, setQuery] = useState('');
  const { data: hubApps = [] } = useQuery(['hub-app-profiles'], getAllHubAppProfiles, { staleTime: 5 * 60 * 1000 });

  const fetchAccounts = useCallback(
    async ({ page = 1 } = {}) => {
      setLoading(true);
      try {
        const limit = pagination.pageSize || 10;
        const q = query || '';
        const response = await apiClient.get(
          `/zoho-accounts/admin/list?page=${page}&limit=${limit}&q=${encodeURIComponent(q)}`
        );
        setAccounts(response.data.zohoAccounts);
        setPagination((prev) => ({ ...prev, current: page, total: response.data.total }));
      } catch (error) {
        console.error('Failed to fetch zoho accounts', error);
        message.error('Failed to fetch zoho accounts');
      } finally {
        setLoading(false);
      }
    },
    [pagination.pageSize, query]
  );

  useEffect(() => {
    fetchAccounts({ page: 1 });
  }, [fetchAccounts]);

  const handleTableChange = (pg) => {
    fetchAccounts({ page: pg.current });
  };

  const handleSearch = () => {
    fetchAccounts({ page: 1 });
  };

  const columns = [
    { title: 'Shopify URL', dataIndex: 'shopifyUrl', key: 'shopifyUrl' },
    { title: 'Store', dataIndex: 'accountName', key: 'accountName' },
    { title: 'Plan Display', dataIndex: 'shopifyPlanDisplayName', key: 'shopifyPlanDisplayName' },
    { title: 'Plan Name', dataIndex: 'shopifyPlanName', key: 'shopifyPlanName' },
    { title: 'SEO Plan', dataIndex: 'seoPlan', key: 'seoPlan' },
    { title: 'Feed Plan', dataIndex: 'feedPlan', key: 'feedPlan' },
    { title: 'Blog Plan', dataIndex: 'blogPlan', key: 'blogPlan' },
    { title: 'CS Notes', dataIndex: 'csNotes', key: 'csNotes', render: (text) => text || '-' },
    { title: 'CS_ID_Notes', dataIndex: 'csIdNotes', key: 'csIdNotes', render: (text) => text || '-' },
    { title: 'SEO AI per month', dataIndex: 'seoAiMetaPerMonth', key: 'seoAiMetaPerMonth' },
    { title: 'Shopify Email', dataIndex: 'shopifyEmail', key: 'shopifyEmail' },
    ...hubApps
      .filter((app) => app.ratingField?.fieldKey)
      .map((app) => {
        const dataKey = toCamelCase(app.ratingField.fieldKey);
        return {
          title: app.ratingField.fieldName,
          dataIndex: dataKey,
          key: dataKey,
        };
      }),
  ];

  return (
    <div style={{ padding: 24 }}>
      <Card title="Zoho Accounts (read-only)" style={{ marginBottom: 24 }}>
        <div style={{ marginBottom: 16 }}>
          <Input
            placeholder="Search by shop URL or account name"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            style={{ width: 300, marginRight: 8 }}
          />
          <Button type="primary" onClick={handleSearch}>
            Search
          </Button>
        </div>

        <Table
          columns={columns}
          dataSource={accounts}
          rowKey={(r) => r._id}
          pagination={pagination}
          loading={loading}
          onChange={handleTableChange}
        />
      </Card>
    </div>
  );
};

export default ZohoAccounts;

